/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import PageLoading from 'loracoms/PageLoading';
import PageNoPerm from 'loracoms/PageNoPerm';


const propTypes = {
  plan: React.PropTypes.object.isRequired,
  children: React.PropTypes.node.isRequired,
};

class ChannelView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      plan: props.plan,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { plan } = nextProps;
    if (plan !== this.props.plan) {
      this.setState({ plan });
    }
  }

  render() {
    const { plan } = this.state;
    if (plan.status !== 'success') {
      return <PageLoading />;
    }
    if (plan.tier === 1) {
      return <PageNoPerm />;
    }

    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}

ChannelView.propTypes = propTypes;


const mapStateToProps = state => ({
  plan: state.billing.plan,
});

export default connect(
  mapStateToProps,
  null,
)(injectIntl(ChannelView));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/ChannelView/index.jsx